import { create } from "zustand"

const useHoldOrders = create((set) => ({
  holdOrders: [],
  holdOrdersCount: 0, // State variable to hold the count of objects in the array
  loading: true,
  setHoldOrders: (orders) =>
    set({ holdOrders: orders, holdOrdersCount: orders.length, loading: false }),
  setHoldOrsersLoading: (loadingState) => set({ loading: loadingState }),
}))

export default useHoldOrders
